import { Box, Stack } from '@mui/material'
import { Title, useTranslate } from 'react-admin'
import { CalendarCard } from './CalendarCard'
import { TwoFactorCard } from './TwoFactorCard'

/** "Mein Konto": what each person sets up for themselves. */
export const Account = () => {
  const translate = useTranslate()
  return (
    <Box sx={{ p: 2, minWidth: 0 }}>
      <Title title={translate('account.title')} />
      <Stack spacing={2}>
        <CalendarCard />
        <TwoFactorCard />
      </Stack>
    </Box>
  )
}

export default Account
